// @ts-nocheck
/* eslint-disable */
import { elioInterrogationPointCircleIcon } from './interrogation_point_circle';
export const landingPageIcons = [elioInterrogationPointCircleIcon];
